import { ContentBox } from '@/components/shared/content-box';
import { Chip, Stack, Typography } from '@mui/material';

export const Chips = () => {
  return (
    <Stack spacing={2}>
      <Typography variant="h2">Chips</Typography>
      <ContentBox gap={1}>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Chip label="primary" color="primary" />
          <Chip label="secondary" color="secondary" />
          <Chip label="error" color="error" />
          <Chip label="warning" color="warning" />
          <Chip label="info" color="info" />
          <Chip label="success" color="success" />
          <Chip label="default" color="default" />
        </Stack>
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Chip label="primary" variant="outlined" color="primary" />
          <Chip label="secondary" color="secondary" variant="outlined" />
          <Chip label="error" color="error" variant="outlined" />
          <Chip label="warning" color="warning" variant="outlined" />
          <Chip label="info" color="info" variant="outlined" />
          <Chip label="success" color="success" variant="outlined" />
          <Chip label="default" color="default" variant="outlined" />
        </Stack>
      </ContentBox>
    </Stack>
  );
};
